import styled from 'styled-components';

const Container = styled.div`
  border-top: 2px solid #666;
  padding: 15px 0;
`;
const Heading = styled.h2`
  margin-top: 0;
  font-weight: 600;
  padding-bottom: 13px;
  font-size: 14px;
  border-bottom: 1px solid #eee;
  margin-bottom: 0;
`;

const Form = styled.div`
  margin: 15px 0;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  margin-top: 0;
  gap: 20px;
  margin: 1em 0;
  align-items: center;
  @media (max-width: 650px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const Submit = styled.div`
  text-align: center;
`;
export { Container, Heading, Form, Submit };
